<!-- @format -->

<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<app-warning-label
  textColor="#505050"
  [icon]="true"
  color="#E5EFFD"
></app-warning-label>
<!-- <div class="error_message" *ngIf="secondPage && showCapital">
  <div>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99859 8.74987V11.8749M2.24588 14.6879C1.52473 15.9379 2.42687 17.4999 3.86998 17.4999H16.1272C17.5703 17.4999 18.4724 15.9379 17.7513 14.6879L11.6227 4.06497C10.9011 2.81428 9.09604 2.81428 8.37449 4.06497L2.24588 14.6879ZM9.99859 14.3749H10.0048V14.3811H9.99859V14.3749Z"
        stroke="#FB4037"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
  <div>
    <p>
      Please fill in the total shares capital
      <span (click)="editShares()">here</span> to edit the Shares Allocated.
    </p>
  </div>
</div> -->
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<div class="goBack" (click)="previousStep()" *ngIf="step > 1 && !pendingArr.length">
  <img src="assets/icons/chevron-right.svg" />
  <p>Go back</p>
</div>

<div
  class="content ui basic segment"
  [ngClass]="{ loading: pendingArr.length }"
  style="padding: 0; margin: 0"
>
  <div class="scroll-wrapper ui basic segment" style="padding: 24px 20px">
    <div class="ui form" [formGroup]="companyDirectorForm">
      <div *ngIf="step === 1 && !modal.context.isEdit">
        <p class="topic">
          What is the company ownership type?
          <span class="required-input">*</span>
        </p>
        <div
          class="field"
          *ngFor="let companyOwnershipType of companyOwnershipTypes"
        >
          <sui-radio-button
            [name]="'companyOwnershipType'"
            [value]="companyOwnershipType.optionId"
            formControlName="companyOwnershipTypeId"
            [(ngModel)]="selectedCompanyOwnershipType"
            >{{ companyOwnershipType.optionName }}</sui-radio-button
          >
        </div>

        <div
          *ngIf="
            companyDirectorForm.get('companyOwnershipTypeId').value !==
            'foreign_owned'
          "
        >
          <p class="topic" style="margin-top: 24px">
            What is the company type? <span class="required-input">*</span>
          </p>
          <div class="field" *ngFor="let companyType of companyTypes">
            <sui-radio-button
              [name]="'companyType'"
              [value]="companyType.optionId"
              formControlName="actualCompanyTypeId"
              [(ngModel)]="selectedCompanyType"
              >{{ companyType.optionName }}</sui-radio-button
            >
          </div>

          <p class="topic" style="margin-top: 24px">
            Company RC/BN Number <span class="required-input">*</span>
          </p>
          <p>Please enter only numbers, other characters are not allowed.</p>
          <div class="field required">
            <input
              #input
              type="number"
              formControlName="rcNumber"
              placeholder="e.g 1234567"
            />
          </div>
        </div>

        <div
          *ngIf="
            companyDirectorForm.get('companyOwnershipTypeId').value ===
            'foreign_owned'
          "
        >
          <div
            class="required field"
            [ngClass]="displayFieldCss('companyName')"
          >
            <label>Company Name</label>
            <input
              #input
              formControlName="companyName"
              type="text"
              placeholder="Company Name"
            />
            <app-field-error-display
              [displayError]="isFieldValid('companyName')"
              errorMsg="Please enter  Company Name"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('companyRegNumber')"
          >
            <label>Company Registration Number</label>
            <input
              #input
              formControlName="companyRegNumber"
              type="text"
              placeholder="Company Registration Number"
            />
            <app-field-error-display
              [displayError]="isFieldValid('companyRegNumber')"
              errorMsg="Please enter Company Registration Number"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('businessInformationProvider')"
          >
            <label>Third Party Business Information Provider</label>

            <sui-select
              class="selection"
              placeholder="Select Third Party Business Provider"
              formControlName="businessInformationProvider"
              [options]="bizProvider"
              labelField="optionName"
              valueField="optionName"
              [isSearchable]="true"
              #bizState
            >
              <sui-select-option
                *ngFor="let option of bizState.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
            <app-field-error-display
              [displayError]="isFieldValid('businessInformationProvider')"
              errorMsg="Please enter Third Party Business Information Provider"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('businessInformationProviderId')"
          >
            <label>Third Party Business Information Provider ID</label>
            <input
              #input
              formControlName="businessInformationProviderId"
              type="text"
              placeholder="Select Third Party Business Provider ID"
            />
            <app-field-error-display
              [displayError]="isFieldValid('businessInformationProviderId')"
              errorMsg="Please enter Third Party Business Information Provider ID"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('companyEmail')"
          >
            <label>Email Address</label>
            <input
              formControlName="companyEmail"
              type="email"
              placeholder="Enter Company Email Address"
            />
            <app-field-error-display
              [displayError]="isFieldValid('companyEmail')"
              errorMsg="Please enter a valid email"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('reCompanyEmail')"
          >
            <label>Re-Enter Email Address</label>
            <input
              formControlName="reCompanyEmail"
              type="email"
              placeholder="Re-Enter Company Email Address"
            />
            <app-field-error-display
              [displayError]="isFieldValid('reCompanyEmail')"
              errorMsg="Please re-enter the email address"
            >
            </app-field-error-display>
          </div>
        </div>
      </div>

      <div *ngIf="step === 2 && !modal.context.isEdit">
        <p class="topic">Please verify the company name below</p>
        <p class="company-name">
          Is the name of the company <b>"{{ company?.approvedName }}"</b>?
        </p>

        <div class="field" *ngFor="let option of verifyOptions">
          <sui-radio-button
            [name]="'verifyCompanyName'"
            [value]="option.value"
            formControlName="verifyCompanyName"
            [(ngModel)]="verifyCompanyName"
            >{{ option.name }}</sui-radio-button
          >
        </div>
      </div>

      <div *ngIf="step === 3 || modal.context.isEdit">
        <p class="topic">Shareholding Information</p>

        <div class="ui divider"></div>

        <div class="required field" [ngClass]="displayFieldCss('companyName')">
          <label>Company Name</label>
          <input
            #input
            formControlName="companyName"
            type="text"
            placeholder="Company Name"
            disabled
          />
          <app-field-error-display
            [displayError]="isFieldValid('companyName')"
            errorMsg="Please enter  Company Name"
          >
          </app-field-error-display>
        </div>

        <div
          class="required field"
          [ngClass]="displayFieldCss('companyRegNumber')"
        >
          <label>Company Registration Number</label>
          <input
            #input
            formControlName="companyRegNumber"
            type="text"
            placeholder="Company Registration Number"
            disabled
          />
          <app-field-error-display
            [displayError]="isFieldValid('companyRegNumber')"
            errorMsg="Please enter Company Registration Number"
          >
          </app-field-error-display>
        </div>

        <div
          *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
          class="required field"
          [ngClass]="displayFieldCss('shareAllocated')"
        >
          <label>Shares Allocated</label>
          <app-currencyfmt-number-input
            [placeholder]="'Share Allocated'"
            formControlName="shareAllocated"
            [ngClass]="{
              border_red: showCapital
            }"
          ></app-currencyfmt-number-input>
          <app-field-error-display
            [displayError]="isFieldValid('shareAllocated')"
            errorMsg="Please enter Shares Allocated"
          >
          </app-field-error-display>
        </div>

        <div
          *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
          class="required field"
          [ngClass]="displayFieldCss('shareCapital')"
        >
          <label>Total Share Capital</label>
          <app-currencyfmt-number-input
            [placeholder]="'Total Share Capital'"
            formControlName="shareCapital"
            [disabled]="true"
          ></app-currencyfmt-number-input>
          <app-field-error-display
            [displayError]="isFieldValid('shareCapital')"
            errorMsg="Please enter Total Share Capital"
          >
          </app-field-error-display>
        </div>

        <div
          *ngIf="affiliateTypeId === 'shareholder_type'"
          class="required field"
          [ngClass]="displayFieldCss('shareholding')"
        >
          <label>Percentage of Share Capital</label>
          <input
            *ngIf="!usePercentage"
            formControlName="shareholding"
            type="number"
            disabled
            appRestrictToGreaterThanZero
            placeholder="3%"
          />
          <input
            *ngIf="usePercentage"
            formControlName="shareholding"
            type="number"
            appRestrictToGreaterThanZero
            placeholder="3%"
          />
          <app-field-error-display
            [displayError]="isFieldValid('shareholding')"
            errorMsg="Please enter Percentage of Share Capital"
          >
          </app-field-error-display>
        </div>

        <div
          style="
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #3f4395;
            margin-bottom: 16px;
            margin-top: 24px;
          "
        >
          Company Representative Information
        </div>

        <div *ngIf="!modal.context.isEdit" style="margin-bottom: 24px">
          <div class="field" *ngFor="let option of linkOrAdd">
            <sui-radio-button
              [name]="'linkOrAddValue'"
              [value]="option.value"
              formControlName="linkOrAddValue"
              [(ngModel)]="linkOrAddValue"
              >{{ option.name }}</sui-radio-button
            >
          </div>
        </div>

        <div *ngIf="linkOrAddValue === 'link'">
          <div class="topic">
            {{
              secondExistingPage
                ? "Individual's Information"
                : "Select to link an existing individual"
            }}
          </div>
          <div class="ui divider"></div>
          <div class="show" *ngIf="!this.secondExistingPage">
            <div
              class="individual_container"
              *ngFor="let director of companyDirectors; let i = index"
            >
              <sui-checkbox
                style="width: 100%; display: flex; align-items: center"
                name="timer"
                class="new-timer"
                [(ngModel)]="director.checkbox"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onBoxChecked(director, $event)"
              >
                <div class="existing_individual">
                  <div></div>
                  <div class="image">
                    <img
                      *ngIf="director.photographDocumentPath"
                      src="{{ baseUrl }}/public/image/?media={{
                        director?.photographDocumentPath
                      }}"
                    />
                    <img
                      *ngIf="!director.photographDocumentPath"
                      src="assets/avatar/1.jpg"
                    />
                  </div>
                  <div class="information">
                    <div>
                      <h1>
                        {{ director?.firstName }} {{ director?.lastName }}
                      </h1>
                    </div>
                    <div class="flex">
                      <img src="assets/icons/email.svg" />
                      <p>{{ director?.email }}</p>
                    </div>
                    <div class="flex">
                      <img src="assets/icons/outline-two.svg" />
                      <p>{{ director?.phoneNumber }}</p>
                    </div>
                  </div>
                </div></sui-checkbox
              >
            </div>
            <app-no-record-found
              *ngIf="companyDirectors && companyDirectors?.length < 1"
            ></app-no-record-found>
          </div>
          <div class="show_second" *ngIf="this.secondExistingPage">
            <div class="individual_container">
              <div
                style="width: 100%; display: flex; align-items: center"
                name="timer"
                class="new-timer"
              >
                <div class="existing_individual">
                  <div></div>
                  <div class="image">
                    <img
                      *ngIf="getChosenExistingResult().photographDocumentPath"
                      src="{{ baseUrl }}/public/image/?media={{
                        getChosenExistingResult()?.photographDocumentPath
                      }}"
                    />
                    <img
                      *ngIf="!getChosenExistingResult().photographDocumentPath"
                      src="assets/avatar/1.jpg"
                    />
                  </div>
                  <div class="information">
                    <div>
                      <h1>
                        {{ getChosenExistingResult()?.firstName }}
                        {{ getChosenExistingResult()?.lastName }}
                      </h1>
                    </div>
                    <div class="flex">
                      <img src="assets/icons/email.svg" />
                      <p>{{ getChosenExistingResult()?.email }}</p>
                    </div>
                    <div class="flex">
                      <img src="assets/icons/outline-two.svg" />
                      <p>{{ getChosenExistingResult()?.phoneNumber }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui form" [formGroup]="companyDirectorForm">
              <div
                *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
                class="required field"
                [ngClass]="displayFieldCss('shareCapital')"
              >
                <label>Total Share Capital</label>
                <!-- <input
                  #input
                  formControlName="shareCapital"
                  type="text"
                  placeholder="200,000,000,000,000"
                  disabled
                /> -->
                <app-currencyfmt-number-input
                  [placeholder]="'Total Share Capital'"
                  formControlName="shareCapital"
                  [disabled]="true"
                ></app-currencyfmt-number-input>
                <app-field-error-display
                  [displayError]="isFieldValid('shareCapital')"
                  errorMsg="Please enter Total Share Capital"
                >
                </app-field-error-display>
              </div>
              <div
                *ngIf="affiliateTypeId === 'shareholder_type' && !usePercentage"
                class="required field"
                [ngClass]="displayFieldCss('shareAllocated')"
              >
                <label>Shares Allocated</label>
                <!-- <input
                  #input
                  formControlName="shareAllocated"
                  type="text"
                  [ngClass]="{
                    border_red: showCapital
                  }"
                  placeholder="1,000,000,000"
                /> -->
                <app-currencyfmt-number-input
                  [placeholder]="'Share Allocated'"
                  formControlName="shareAllocated"
                  [ngClass]="{
                    border_red: showCapital
                  }"
                ></app-currencyfmt-number-input>
                <app-field-error-display
                  [displayError]="isFieldValid('shareAllocated')"
                  errorMsg="Please enter Shares Allocated"
                >
                </app-field-error-display>
              </div>
              <div
                *ngIf="affiliateTypeId === 'shareholder_type'"
                class="required field"
                [ngClass]="displayFieldCss('shareholding')"
              >
                <label>Percentage of Share Capital</label>
                <input
                  *ngIf="!usePercentage"
                  formControlName="shareholding"
                  type="number"
                  disabled
                  appRestrictToGreaterThanZero
                  placeholder="3%"
                />
                <input
                  *ngIf="usePercentage"
                  formControlName="shareholding"
                  type="number"
                  appRestrictToGreaterThanZero
                  placeholder="3%"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('shareholding')"
                  errorMsg="Please enter Percentage of Share Capital"
                >
                </app-field-error-display>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="linkOrAddValue === 'add'">
          <p class="topic">Bio Data</p>

          <div class="ui divider"></div>

          <div class="image_container">
            <div *ngIf="!imageUrl" class="plus_box" (click)="uploader.click()">
              <img src="assets/icons/add_24px.svg" />
            </div>
            <div *ngIf="imageUrl" class="image_box" (click)="uploader.click()">
              <img [src]="imageUrl" alt="Uploaded Image" />
              <div class="cancel_icon">
                <i class="cancel icon" (click)="deleteImage($event)"></i>
              </div>
            </div>
            <input
              type="file"
              accept=".jpg, .jpeg, .png, .JPG, .JPEG"
              #uploader
              (change)="onFileChangeData($event)"
              placeholder="Browse for documents"
              onclick="value = null"
              style="display: none"
            />
            <p>{{ fileNamePhoto ? fileNamePhoto : "Upload Photo here" }}</p>
          </div>

          <div class="required field" [ngClass]="displayFieldCss('firstName')">
            <label>First Name</label>
            <input
              #input
              formControlName="firstName"
              type="text"
              placeholder="First Name"
            />
            <app-field-error-display
              [displayError]="isFieldValid('firstName')"
              errorMsg="Please enter  FirstName"
            >
            </app-field-error-display>
          </div>

          <div class="required field" [ngClass]="displayFieldCss('lastName')">
            <label>Last Name</label>
            <input
              formControlName="lastName"
              type="text"
              placeholder="Last Name"
            />
            <app-field-error-display
              [displayError]="isFieldValid('lastName')"
              errorMsg="Please enter  LastName"
            >
            </app-field-error-display>
          </div>

          <div class="field" [ngClass]="displayFieldCss('middleName')">
            <label>Middlename</label>
            <input
              formControlName="middleName"
              type="text"
              placeholder="Middle Name"
            />
            <app-field-error-display
              [displayError]="isFieldValid('middleName')"
              errorMsg="Please enter Middle Name"
            >
            </app-field-error-display>
          </div>

          <div class="required field" [ngClass]="displayFieldCss('gender')">
            <label>Gender</label>
            <select formControlName="gender" class="ui search dropdown">
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            <app-field-error-display
              [displayError]="isFieldValid('gender')"
              errorMsg="Please select your Gender"
            >
            </app-field-error-display>
          </div>

          <div class="required field" [ngClass]="displayFieldCss('address')">
            <label>Address</label>
            <input
              formControlName="address"
              type="text"
              placeholder="Address"
            />
            <app-field-error-display
              [displayError]="isFieldValid('address')"
              errorMsg="Please enter address"
            >
            </app-field-error-display>
          </div>

          <p class="topic" style="margin-top: 24px">Nationality</p>

          <div class="ui divider"></div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('nationalityId')"
          >
            <label>Nationality</label>
            <select class="ui search dropdown" formControlName="nationalityId">
              <option
                *ngFor="let country of countries"
                value="{{ country?.countryCode }}"
              >
                {{ country?.countryName }}
              </option>
            </select>
            <app-field-error-display
              [displayError]="isFieldValid('nationalityId')"
              errorMsg="Please select your Nationality"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('countryOfOriginId')"
          >
            <label>Country of Origin</label>
            <select
              formControlName="countryOfOriginId"
              class="ui search dropdown"
            >
              <option
                *ngFor="let country of countries"
                value="{{ country?.countryCode }}"
              >
                {{ country?.countryName }}
              </option>
            </select>
            <app-field-error-display
              [displayError]="isFieldValid('countryOfOriginId')"
              errorMsg="Please select your Country of Origin"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('meansOfIdentificationId')"
            *ngIf="
              companyDirectorForm.get('nationalityId').value &&
              companyDirectorForm.get('nationalityId').value !== 'NG'
            "
          >
            <label>Means of Identification</label>
            <select
              class="ui search dropdown"
              formControlName="meansOfIdentificationId"
            >
              <option
                *ngFor="let means of meansOfIdentifications"
                value="{{ means?.optionId }}"
              >
                {{ means?.optionName }}
              </option>
            </select>
            <app-field-error-display
              [displayError]="isFieldValid('meansOfIdentificationId')"
              errorMsg="Please select your Means of Identification"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('nationalIdNumber')"
            *ngIf="companyDirectorForm.get('nationalityId').value === 'NG'"
          >
            <label>National ID Number</label>
            <input
              formControlName="nationalIdNumber"
              type="text"
              placeholder="National ID Number"
            />
            <app-field-error-display
              [displayError]="isFieldValid('nationalIdNumber')"
              errorMsg="Please Enter National ID Number"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('nationalIdNumber')"
            *ngIf="
              companyDirectorForm.get('nationalityId').value &&
              companyDirectorForm.get('nationalityId').value !== 'NG' &&
              companyDirectorForm.get('meansOfIdentificationId').value
            "
          >
            <label>Identification Number</label>
            <input
              formControlName="identificationNumber"
              type="text"
              placeholder="Identification Number"
            />
            <app-field-error-display
              [displayError]="isFieldValid('identificationNumber')"
              errorMsg="Please Enter Identification Number"
            >
            </app-field-error-display>
          </div>

          <div *ngIf="showSupportingDocuments()">
            <p class="topic" style="margin-top: 24px">
              Upload Supporting Document(s)
            </p>
            <p class="subtopic">
              Only .pdf, .jpg, .jpeg, .png files. 1mb max file size.
            </p>

            <div *ngIf="supportingDocumentError" tamsyMargin marginY="10px">
              <esl-message-toast
                [(message)]="supportingDocumentError"
              ></esl-message-toast>
            </div>

            <p
              style="
                display: flex;
                align-items: center;
                gap: 10px;
                justify-content: space-between;
              "
            >
              <span>
                Upload
                {{
                  companyDirectorForm.get("nationalityId").value === "NG"
                    ? "NIN (Photo of a slip, ID Card)"
                    : getMeansOfIdentificationText()
                }}
              </span>
              <button class="ui tiny icon button" (click)="uploader2.click()">
                <i class="plus icon"></i>
              </button>

              <input
                hidden
                type="file"
                name="file2"
                id="file2"
                #uploader2
                accept=".pdf, .jpg, .jpeg, .png"
                style="display: none"
                multiple="false"
                (change)="uploadImage($event.target.files[0])"
              />
            </p>
            <div class="ui divider"></div>

            <div *ngFor="let file of documents; let fileIndex = index">
              <div class="added_document" *ngIf="file">
                <div class="contents" *ngIf="file">
                  <div class="image">
                    <img src="assets/icons/Frame.svg" alt="" />
                  </div>
                  <div class="content_name">
                    <h5>
                      {{
                        file.documentPath.split("/")[
                          file.documentPath.split("/").length - 1
                        ]
                      }}
                    </h5>
                  </div>
                </div>
                <div class="action_button">
                  <img
                    src="assets/icons/Frame 5492.svg"
                    suiPopup
                    [popupInverted]="true"
                    popupPlacement="bottom"
                    popupText="View"
                    (click)="viewDocument(file)"
                    alt=""
                  />
                  <img
                    src="assets/icons/trash.svg"
                    (click)="removeDocument(fileIndex)"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <div
              class="added_document"
              *ngFor="let file of supportingDocuments; let fileIndex = index"
            >
              <div class="contents">
                <div class="image">
                  <img src="assets/icons/Frame.svg" alt="" />
                </div>
                <div class="content_name">
                  <h5>
                    {{ file.name }}
                  </h5>
                </div>
              </div>
              <div class="action_button">
                <img
                  src="assets/icons/Frame 5492.svg"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="View"
                  (click)="viewFiles(file)"
                  alt=""
                />
                <img
                  src="assets/icons/trash.svg"
                  (click)="removeFile(fileIndex)"
                  alt=""
                />
              </div>
            </div>
          </div>

          <p class="topic" style="margin-top: 24px">Contact Information</p>

          <div class="ui divider"></div>

          <div class="required field" [ngClass]="displayFieldCss('email')">
            <label>Email</label>
            <input formControlName="email" type="email" placeholder="Email" />
            <app-field-error-display
              [displayError]="isFieldValid('email')"
              errorMsg="Please enter a valid email"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displayFieldCss('phoneNumber')"
          >
            <label>Phone Number</label>
            <input
              formControlName="phoneNumber"
              maxlength="11"
              placeholder="Phone Number"
            />
            <app-field-error-display
              [displayError]="isFieldValid('phoneNumber')"
              errorMsg="Please enter 11 digit phone number"
            >
            </app-field-error-display>
          </div>
        </div>
        <div appMargin marginB="7"></div>
      </div>
    </div>
  </div>
</div>
<div class="actions" style="background: inherit; border: none">
  <button
    class="ui basic primary button"
    (click)="modal.deny(undefined)"
    [disabled]="pendingArr.length"
  >
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pendingArr.lenght }"
    [disabled]="pending || !this.companyDirectorForm.value.verifyCompanyName"
    (click)="nextStep()"
    autofocus
    *ngIf="!modal.context.isEdit && step === 2"
  >
    Continue
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pendingArr.length }"
    [disabled]="isStep1BtnDisabled"
    (click)="nextStep()"
    autofocus
    *ngIf="!modal.context.isEdit && step === 1"
  >
    Continue
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pendingArr.length }"
    [disabled]="isAddBtnDisabled"
    (click)="submit()"
    autofocus
    *ngIf="modal.context.isEdit || step === 3"
  >
    {{ modal.context.isEdit ? "Update" : "Add" }}
  </button>
</div>
